(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["enquery-form"] && !Shopify.designMode) return;
  try {
    class DialogManager {
  #selectors = {
    dialog: '#enquery_form_dioalog',
    form: '#sell-with-us',
    menu: '#header-menu',
    successMsg: '.form-success-message',
    closeBtn: '.enquery_form_wrap .drawer__close'
  };

  constructor() {
    Object.entries(this.#selectors).forEach(([key, sel]) => {
      this[key] = document.querySelector(sel);
    });
    this.init();
  }

  init() {
    document.body.addEventListener("click", e => this.#handleClick(e));
    this.form?.addEventListener('submit', () => sessionStorage.setItem('formSubmitted', 'sell-with-us'));
    this.checkFormSuccess();
  }

  #handleClick = (e) => {
    const { target } = e;
    const openBtn = target.closest("[data-open-dialog]");
    
    openBtn && (
      document.getElementById(openBtn.dataset.openDialog)?.showModal(),
      this.menu?.classList.remove("drawer--visible"),
      document.body.style.overflow = "auto"
    );

    target.closest(this.#selectors.closeBtn) && target.closest("dialog")?.close();
    
    target.tagName === "DIALOG" && target.close();
  }

  checkFormSuccess() {
    const [successMsg, formElement] = [this.successMsg, this.dialog?.querySelector('form')];
    
    sessionStorage.getItem('formSubmitted') === 'sell-with-us' && 
    this.dialog && successMsg && formElement && (() => {
      this.dialog.showModal();
      [successMsg.style.display, formElement.style.display] = ['block', 'none'];
      
      setTimeout(() => {
        this.dialog.close();
        [successMsg.style.display, formElement.style.display] = ['none', 'block'];
        formElement.reset();
        sessionStorage.removeItem('formSubmitted');
      }, 3000);
    })();
  }
}

new DialogManager();
  } catch(e) { console.error(e); }
})();

})();
